import React from 'react';
import classnames from 'classnames/bind';
import style from './index.module.scss';

interface IToggleFilterProps {
    panelVisible: boolean,
    toggleHandler: (value: boolean) => void
}

const cx = classnames.bind(style);

function ToggleFilter(props: IToggleFilterProps) {
  const {panelVisible, toggleHandler} = props;
  return (
    <div className={cx('toggle-panel', {'shown': !panelVisible})}>
      <span className={cx('selected')} onClick={() => toggleHandler(!panelVisible)}>
        {!panelVisible ? 'Show more filters' : 'Hide filters'}
      </span>
    </div>
  );
}

export default ToggleFilter;
